import api from "./requests"
import {PASSWORD} from "./consts"

export const Service = new class Service {
    // Все данные
    async getUsers() {
        return (
            await api.get(`/users`)
        ).data
    }

    // Пользователи
    async createUser(user) {
        return (
            await api.post(`/user`, {
                ...user, password: localStorage.getItem(PASSWORD)
            })
        ).data
    }


    async updateUser(user) {
        return (
            await api.put(`/user`, {
                ...user, password: localStorage.getItem(PASSWORD)
            })
        ).data
    }

    async deleteUser(user) {
        return (
            await api.delete(`/user`, {
                data: {
                    ...user,
                    password: localStorage.getItem(PASSWORD)
                }
            })
        ).data
    }

    // Проекты
    async createProject(project) {
        return (
            await api.post(`/project`, {
                ...project, password: localStorage.getItem(PASSWORD)
            })
        ).data
    }


    async updateProject(project) {
        return (
            await api.put(`/project`, {
                ...project, password: localStorage.getItem(PASSWORD)
            })
        ).data
    }

    async deleteProject(project) {
        return (
            await api.delete(`/project`, {
                data: {
                    ...project,
                    password: localStorage.getItem(PASSWORD)
                }
            })
        ).data
    }

    // Комментарии
    async getComments() {
        return (
            await api.get(`/comments`)
        ).data
    }
}